<script setup>

import { KNOLIA } from "@/knolia"
import { ref, defineEmits, onMounted } from "vue"

const emits = defineEmits(['close-profile-modal'])
const userData = ref({})
const defaultImg = ref(require('@/images/default.png'))

onMounted(async () => {
    const response = await KNOLIA.CallBackEnd('get', `get-user`)
    userData.value = response.data.user
})

</script>

<template>
    <div id="div-container-modal" class="modal">
        <div id="div-user-content" class="modal-content">
            <div class="close-modal">
                <i class="fas fa-times" @click="emits('close-profile-modal')"></i>
            </div>

                <div class="user-container">
                    <div class="div-photo">
                        <label for="file">
                            <div class="photo">
                                <img id="photo-usr" class="cover" :src="userData.src ?? defaultImg" alt="user-image" @error="$event.target.src = defaultImg">
                            </div>
                        </label>
                    </div>

                    <div id="DivLine" class="div-separation-line"></div>

                    <section class="section">
                        <div class="div-splitted-inputs">
                            <div class="div-input-left">
                                <label>N° INTERNO</label>
                                <input type="text" :placeholder="userData.user_internal" :disabled="true" />
                            </div>

                            <div class="div-input-right">
                                <label>NOME PROFISSIONAL</label>
                                <input type="text" :placeholder="userData.professional_name" :disabled="true" />
                            </div>
                        </div>

                        <div class="div-row">
                            <label>NOME COMPLETO</label>
                            <input type="text" :placeholder="userData.complete_name" :disabled="true" />
                        </div>

                        <div class="div-row">
                            <label for="">FUNÇÃO</label>
                            <input type="text" :placeholder="userData.user_job" :disabled="true" />
                        </div>

                        <div class="div-row">
                            <label>EMAIL</label>
                            <input type="text" :placeholder="userData.user_email" :disabled="true" />
                        </div>
                    </section>
                </div>
        </div>
    </div>
</template>

<style scoped>

.modal-content {
    position: absolute;
    top: 2%;
    left: 25%;
    transform: translate(0, 0);
}

#div-save-user-data {
    display: flex;
    align-items: center;
    gap: 20px;
    font-size: 1.2em;
}

#div-user-img {
    margin: 0 auto;
    cursor: pointer;
    width: 150px;
}

.div-logo {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    object-fit: cover;
}

.div-group {
    padding: 10px 20px;
    display: flex;
    gap: 10px;
}

.div-user-input>* {
    width: -webkit-fill-available;
}

label {
    font-weight: bold;
    margin-right: 5px;
    display: block;
}


.div-assigned-team {
    border-radius: var(--default-app-radius);
    border: 1px solid;
    padding: 10px 15px;
    margin: 5px 5px 5px 0px;
}

#div-assigned-teams {
    display: flex;
    margin-top: 5px;
    flex-wrap: wrap;
}

#div-teams {
    display: flex;
    align-items: center;
}

#div-teams>.fa-plus {
    margin-left: 5px;
}

.file-user-photo {
    cursor: pointer;
    display: none;
}

.div-toggle {
    text-align: center;
}

.div-toggle i {
    font-size: 1.5em;
}

.div-little {
    width: 20%
}

.div-larger {
    width: 80%;
}

.flex-1 {
    flex: 1;
}

.flex-5 {
    flex: 5;
}

.right div:not(:first-child) {
    padding: 10px 0;
}

.ddl-teams {
    width: 95%;
}

.div-toggle-container {
    display: flex;
    gap: 10px;
    justify-content: center;
}

.div-save {
    text-align: end;
}

.btn-save {
    width: 150px;
}

.fa-circle-plus {
    font-size: 1.3em;
    margin-left: 5px;
}

.close-modal {
    display: flex;
    justify-content: flex-end;
    padding: 10px 10px 0px 0px;
}

.close-modal i {
    font-size: 1.5em;
    cursor: pointer;
}

.close-modal i:hover {
  color: var(--default-app-hover-color);
}

.modal-content {
    border: 1px solid;
}

.user-container {
  text-align: left;
  display: flex;
  margin: 2% 7%;
  height: 94%;
}

.section {
  width: 100%;
  max-width: 600px;
}

.div-separation-line {
  display: inline-block;
  border-right: solid 2px var(--default-font-color);
  margin: 0 8% 0 8%;
}

.photo img {
  align-self: center;
  width: 140px;
  height: 140px;
  border-radius: 50%;
}

.photo {
  align-self: center;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  box-shadow: 0 0 15px 5px rgba(30, 40, 50, .2);
  align-content: center;
  text-align-last: center;
}

.icon {
  font-size: 7em;
}

.cover {
  object-fit: cover;
  width: 150px;
  height: 100px;
}

.div-splitted-inputs {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 5px;
  margin-bottom: 10px;
}

.div-splitted-inputs input,
.div-splitted-inputs select {
  width: -webkit-fill-available !important;
}

.section input::placeholder {
    color: #afccff63;
}

.div-input-left {
  max-width: 130px;
}

.div-input-right {
  width: 100%;
}

.div-row {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.div-photo {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
}

</style>